import * as Types from '../actions/Types'
import * as Constants from '../../helpers/Constants'

const INITIAL_STATE = {
  alert: {
    show: false,
    header: '',
    text: '',
    type: Constants.ONE_BUTTON,
    firstButton: { title: '', onPress: () => {} },
    secondButton: { title: '', onPress: () => {} },
    thirdButton: { title: '', onPress: () => {} }
  },
  newUserModal: {
    show: false
  },
  editUserModal: {
    show: false
  },
  selectCommunityModal: {
    show: false
  },
  snackbar: {
    show: false,
    message: ''
  },
  currentPage: Constants.LAUNDRY_TIMES_PAGE,
  editLaundryTimeModal: {
    show: false
  },
  createLaundryTimeModal: {
    show: false
  },
  createLaundryModal: {
    show: false
  },
  editLaundryModal: {
    show: false
  },
  editLaundryTypeModal: {
    show: false
  },
  editBookingRangeModal: {
    show: false
  },
  editMaxBookingsModal: {
    show: false
  },
  editInformationItemModal: {
    show: false
  },
  createInformationItemModal: {
    show: false
  },
  bookOrUnbookLaundryTimeModal: {
    show: false
  },
  createBookingSystemModal: {
    show: false
  },
  editBookingSystemModal: {
    show: false
  },
  createBookingSystemTimeModal: {
    show: false
  },
  editBookingSystemTimeModal: {
    show: false
  }
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
  case Types.SHOW_ALERT:
    return {
      ...state,
      alert: {
        show: true,
        header: payload.header,
        text: payload.text,
        type: payload.type,
        firstButton: payload.firstButton,
        secondButton: payload.secondButton,
        thirdButton: payload.thirdButton
      }
    }
  case Types.HIDE_ALERT:
    return {
      ...state,
      alert: {
        ...state.alert,
        show: false
      }
    }
  case Types.SHOW_NEW_USER_MODAL:
    return {
      ...state,
      newUserModal: {
        ...state.newUserModal,
        show: true
      }
    }
  case Types.HIDE_NEW_USER_MODAL:
    return {
      ...state,
      newUserModal: {
        ...state.newUserModal,
        show: false
      }
    }
  case Types.SHOW_EDIT_USER_MODAL:
    return {
      ...state,
      editUserModal: {
        ...state.editUserModal,
        show: true
      }
    }
  case Types.HIDE_EDIT_USER_MODAL:
    return {
      ...state,
      editUserModal: {
        ...state.editUserModal,
        show: false
      }
    }
  case Types.SHOW_SELECT_COMMUNITY_MODAL:
    return {
      ...state,
      selectCommunityModal: {
        ...state.selectCommunityModal,
        show: true
      }
    }
  case Types.HIDE_SELECT_COMMUNITY_MODAL:
    return {
      ...state,
      selectCommunityModal: {
        ...state.selectCommunityModal,
        show: false
      }
    }
  case Types.SHOW_SNACKBAR:
    return {
      ...state,
      snackbar: {
        show: true,
        message: payload
      }
    }
  case Types.HIDE_SNACKBAR:
    return {
      ...state,
      snackbar: {
        ...state.snackbar,
        show: false
      }
    }
  case Types.SET_CURRENT_PAGE:
    return {
      ...state,
      currentPage: payload
    }
  case Types.SHOW_EDIT_LAUNDRY_TIME_MODAL:
    return {
      ...state,
      editLaundryTimeModal: {
        ...state.editLaundryTimeModal,
        show: true
      }
    }
  case Types.HIDE_EDIT_LAUNDRY_TIME_MODAL:
    return {
      ...state,
      editLaundryTimeModal: {
        ...state.editLaundryTimeModal,
        show: false
      }
    }
  case Types.SHOW_CREATE_LAUNDRY_TIME_MODAL:
    return {
      ...state,
      createLaundryTimeModal: {
        ...state.createLaundryTimeModal,
        show: true
      }
    }
  case Types.HIDE_CREATE_LAUNDRY_TIME_MODAL:
    return {
      ...state,
      createLaundryTimeModal: {
        ...state.createLaundryTimeModal,
        show: false
      }
    }
  case Types.SHOW_EDIT_LAUNDRY_MODAL:
    return {
      ...state,
      editLaundryModal: {
        ...state.editLaundryModal,
        show: true
      }
    }
  case Types.HIDE_EDIT_LAUNDRY_MODAL:
    return {
      ...state,
      editLaundryModal: {
        ...state.editLaundryModal,
        show: false
      }
    }
  case Types.SHOW_CREATE_LAUNDRY_MODAL:
    return {
      ...state,
      createLaundryModal: {
        ...state.createLaundryModal,
        show: true
      }
    }
  case Types.HIDE_CREATE_LAUNDRY_MODAL:
    return {
      ...state,
      createLaundryModal: {
        ...state.createLaundryModal,
        show: false
      }
    }
  case Types.SHOW_EDIT_LAUNDRY_TYPE_MODAL:
    return {
      ...state,
      editLaundryTypeModal: {
        ...state.editLaundryTypeModal,
        show: true
      }
    }
  case Types.HIDE_EDIT_LAUNDRY_TYPE_MODAL:
    return {
      ...state,
      editLaundryTypeModal: {
        ...state.editLaundryTypeModal,
        show: false
      }
    }
  case Types.SHOW_EDIT_BOOKING_RANGE_MODAL:
    return {
      ...state,
      editBookingRangeModal: {
        ...state.editBookingRangeModal,
        show: true
      }
    }
  case Types.HIDE_EDIT_BOOKING_RANGE_MODAL:
    return {
      ...state,
      editBookingRangeModal: {
        ...state.editBookingRangeModal,
        show: false
      }
    }
  case Types.SHOW_EDIT_MAX_BOOKINGS_MODAL:
    return {
      ...state,
      editMaxBookingsModal: {
        ...state.editMaxBookingsModal,
        show: true
      }
    }
  case Types.HIDE_EDIT_MAX_BOOKINGS_MODAL:
    return {
      ...state,
      editMaxBookingsModal: {
        ...state.editMaxBookingsModal,
        show: false
      }
    }
    //
  case Types.SHOW_EDIT_INFORMATION_ITEM_MODAL:
    return {
      ...state,
      editInformationItemModal: {
        ...state.editInformationItemModal,
        show: true
      }
    }
  case Types.HIDE_EDIT_INFORMATION_ITEM_MODAL:
    return {
      ...state,
      editInformationItemModal: {
        ...state.editInformationItemModal,
        show: false
      }
    }
  case Types.SHOW_CREATE_INFORMATION_ITEM_MODAL:
    return {
      ...state,
      createInformationItemModal: {
        ...state.createInformationItemModal,
        show: true
      }
    }
  case Types.HIDE_CREATE_INFORMATION_ITEM_MODAL:
    return {
      ...state,
      createInformationItemModal: {
        ...state.createInformationItemModal,
        show: false
      }
    }
  case Types.SHOW_UNBOOK_LAUNDRY_TIME_MODAL:
    return {
      ...state,
      bookOrUnbookLaundryTimeModal: {
        ...state.bookOrUnbookLaundryTimeModal,
        show: true
      }
    }
  case Types.HIDE_UNBOOK_LAUNDRY_TIME_MODAL:
    return {
      ...state,
      bookOrUnbookLaundryTimeModal: {
        ...state.bookOrUnbookLaundryTimeModal,
        show: false
      }
    }
  case Types.SHOW_CREATE_BOOKING_SYSTEM_MODAL:
    return {
      ...state,
      createBookingSystemModal: {
        ...state.createBookingSystemModal,
        show: true
      }
    }
  case Types.HIDE_CREATE_BOOKING_SYSTEM_MODAL:
    return {
      ...state,
      createBookingSystemModal: {
        ...state.createBookingSystemModal,
        show: false
      }
    }
  case Types.SHOW_EDIT_BOOKING_SYSTEM_MODAL:
    return {
      ...state,
      editBookingSystemModal: {
        ...state.editBookingSystemModal,
        show: true
      }
    }
  case Types.HIDE_EDIT_BOOKING_SYSTEM_MODAL:
    return {
      ...state,
      editBookingSystemModal: {
        ...state.editBookingSystemModal,
        show: false
      }
    }
  case Types.SHOW_CREATE_BOOKING_SYSTEM_TIME_MODAL:
    return {
      ...state,
      createBookingSystemTimeModal: {
        ...state.createBookingSystemTimeModal,
        show: true
      }
    }
  case Types.HIDE_CREATE_BOOKING_SYSTEM_TIME_MODAL:
    return {
      ...state,
      createBookingSystemTimeModal: {
        ...state.createBookingSystemTimeModal,
        show: false
      }
    }
  case Types.SHOW_EDIT_BOOKING_SYSTEM_TIME_MODAL:
    return {
      ...state,
      editBookingSystemTimeModal: {
        ...state.editBookingSystemTimeModal,
        show: true
      }
    }
  case Types.HIDE_EDIT_BOOKING_SYSTEM_TIME_MODAL:
    return {
      ...state,
      editBookingSystemTimeModal: {
        ...state.editBookingSystemTimeModal,
        show: false
      }
    }
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/components/reducers/Config.js